import './Fabrics.css'
import React from 'react'
import axios from 'axios'
import '../../css/table.css'
import { orderBy } from 'lodash'
import ReactTable from 'react-table'
import Card from 'components/Card/Card.jsx'
import { db, storage, keygen } from '../../services/firebase'
import Modal from 'components/Modal/Modal.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import FabricForm from 'forms/FabricForm.jsx'
import { compress, readImage } from '../../services/compressor'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'

export default class Fabrics extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fabrics: [],
            loading: false,
            fabricModal: false,
            imageModal: false,
            alert: null,
            targetFabric: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchFabrics()
    }

    render() {
        const { fabrics, loading, alert } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this.fabricModal()}
                {this.imageModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        this.props.resetForm('FabricForm')
                                        this.setState({ fabricModal: true, targetFabric: null })
                                    }}
                                >
                                    Adicionar Tecido
                            </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <ReactTable
                                    columns={[
                                        { Header: 'Nome', accessor: 'name' },
                                        { Header: 'Faixa de tecido', accessor: 'fabricLineName' },
                                        {
                                            Header: 'Ações', accessor: '',
                                            Cell: ({ value }) => (this._renderTableActions(value))
                                        }
                                    ]}
                                    data={orderBy(fabrics, ['name', 'asc'])}
                                    onFetchData={this._fetchFabrics}
                                    loading={loading}
                                    defaultPageSize={10}
                                    className='-striped -highlight'
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando'
                                    noDataText='Nenhum tecido encontrado'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='Registros'
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                />
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    fabricModal = () => {
        const { fabricModal, targetFabric } = this.state
        return (
            <Modal
                size='modal__small'
                title={targetFabric ? 'Atualizar tecido' : 'Adicionar tecido'}
                isOpen={fabricModal}
                content={
                    <FabricForm
                        initialValues={targetFabric}
                        onSubmit={values => {
                            targetFabric ? this._handleUpdate(values) : this._handleAdd(values)
                        }}
                        handleCancel={() => this.setState({ fabricModal: false })}
                    />
                }
            />
        )
    }

    imageModal = () => {
        const { imageModal, targetFabric } = this.state
        return (
            <Modal
                size='modal__uncontrolled'
                isOpen={imageModal}
                content={
                    <div className='image-modal'>
                        <div className='image-modal__close'>
                            <FontAwesomeIcon
                                className='text-danger'
                                icon='times'
                                onClick={() => this.setState({ targetFabric: null, imageModal: false })}
                            />
                        </div>
                        <div className='image-modal__content'>
                            {targetFabric
                                && (<img src={targetFabric.downloadURL} alt='selected img' width='500' />)
                            }
                        </div>
                    </div>
                }
            />
        )
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`view_image_${value.id}`}>Ver Imagem</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetFabric: value, imageModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='image' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetFabric: value, fabricModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>)}
                onClick={() => this.removeFabricAlert(value.id)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger>
        </div>
    )

    /**************** 
      Form submission
    *****************/

    async _handleAdd(data) {
        this.setState({ fabricModal: false })
        this.waitAlert('Adicionando tecido', true)

        const { name, fabricLine, image } = data
        const extension = this._handleExtension(image)

        if (extension) {
            const key = keygen()
            const imageName = `${key}.${extension}`
            const receivedImage = await readImage(image)
            const compressedImage = await this._compressImage(receivedImage)
            const uploadedImage = await this._uploadImage(compressedImage, imageName)

            this._addFabric({
                name,
                imageName,
                fabricLine: fabricLine.value,
                downloadURL: uploadedImage.downloadURL
            }, key)
        } else {
            this.hideAlert()
            this.props.notify('O arquivo selecionado não é uma imagem.', 'error')
        }
    }

    async _handleUpdate(data) {
        this.setState({ fabricModal: false })
        this.waitAlert('Atualizando tecido', true)

        const { targetFabric } = this.state

        if (data.image) {
            const extension = this._handleExtension(data.image)
            if (extension) {
                const imageName = `${targetFabric.id}.${extension}`
                const receivedImage = await readImage(data.image)
                //eslint-disable-next-line
                await this._removeImage(targetFabric.imageName) //remove current image from storage
                const compressedImage = await this._compressImage(receivedImage) //compress the new image
                const uploadedImage = await this._uploadImage(compressedImage, imageName) //upload the compressed image

                this._updateFabric({
                    imageName,
                    name: data.name,
                    fabricLine: typeof (data.fabricLine) === 'object' ? data.fabricLine.value : data.fabricLine,
                    downloadURL: uploadedImage.downloadURL
                }, targetFabric.id)
            } else {
                this.hideAlert()
                this.props.notify('O arquivo selecionado não é uma imagem.', 'error')
            }
        } else {
            this._updateFabric({
                name: data.name,
                fabricLine: typeof (data.fabricLine) === 'object' ? data.fabricLine.value : data.fabricLine
            }, targetFabric.id)
        }
    }

    _compressImage = async image => await compress(image)

    _uploadImage = async (image, name) => await storage.ref().child(`fabrics/${name}`).put(image)

    _removeImage = async name => await storage.ref().child(`fabrics/${name}`).delete()

    _handleExtension = image => {
        let type = image.type.split('/')
        switch (type[1]) {
            case 'jpeg':
            case 'jpg':
                return 'jpg'
            case 'png':
                return 'png'
            default:
                return null
        }
    }

    /**************** 
      Fetch data from Firestore
    *****************/

    _fetchFabrics = () => {
        this.setState({ loading: true })
        db.collection('fabrics').onSnapshot(snapshot =>
            !snapshot.empty
                ? this._fetchFabricLines(snapshot)
                : this.setState({ loading: false })
        )
    }

    _fetchFabricLines = fabricSnapshot => {
        const fabrics = []
        const promises = []
        fabricSnapshot.forEach(fabric => {
            let f = { ...fabric.data(), id: fabric.id }
            promises.push(
                db.collection('fabric_lines').doc(fabric.data().fabricLine).get()
                    .then(fabricLine => {
                        f.fabricLineName = fabricLine.data().name
                        fabrics.push(f)
                    })
            )
        })

        Promise.all(promises)
            .then(() => this.setState({ loading: false, fabrics }))
            .catch(e => this.props.notify('Erro ao buscar tecidos.', 'error'))
    }

    /**************** 
      Add data to Firestore
    *****************/

    _addFabric(data, key) {
        db.collection('fabrics').doc(key).set(data)
            .then(() => {
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaAddFabrics_HTTPS', {
                    id: key, data
                })
                    .then(() => {
                        this.hideAlert()
                        this.props.notify('Tecido adicionado.', 'success')
                    })
                    .catch(e => {
                        this.hideAlert()
                        this.props.notify('Erro ao sincronizar dados.', 'error')
                    })

            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao adicionar tecido.', 'error')
            })
    }


    /**************** 
      Update Firestore data
  *****************/

    _updateFabric(data, key) {
        db.collection('fabrics').doc(key).update(data)
            .then(() => {
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaUpdateFabrics_HTTPS', {
                    id: key, data
                })
                    .then(() => {
                        this.hideAlert()
                        this.props.notify('Tecido atualizado.', 'success')
                    })
                    .catch(e => {
                        this.hideAlert()
                        this.props.notify('Erro ao sincronizar dados.', 'error')
                    })
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao atualizar tecido.', 'error')
            })
    }

    _removeFabric = id => {
        this.waitAlert('Removendo tecido',false)
        axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaDeleteFabric_HTTPS', { id })
            .then(() => {
                this.hideAlert()
                this.props.notify('Tecido removido.','success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao remover tecido.','error')
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeFabricAlert = fabricID => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeFabric(fabricID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        })
    }

}



// WEBPACK FOOTER //
// ./src/views/Fabrics/Fabrics.jsx